import { PrinterPosPlayIcon } from './PrinterPosPlayIcon';

/**
 * author: Colton Wiscombe
 * id 6737548E-6689-4D50-B84A-186B16B1CE9C
 * name printer-pos-play
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-play.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSalePlayIcon = PrinterPosPlayIcon;
export default PrinterPointOfSalePlayIcon